import script from "./IDatePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./IDatePicker.vue?vue&type=script&setup=true&lang=js"

import "./IDatePicker.vue?vue&type=style&index=0&id=2c0ca084&lang=scss"

const __exports__ = script;

export default __exports__